import request from '@/utils/request'

/**
 * 查询角色元件
 * @param {Object} params
 * @returns
 */
export function listRoleModelDefinition(params) {
  return request({
    url: '/model_definition/role_definition/list',
    method: 'GET',
    params
  })
}

/**
 * 添加角色元件
 * @param {Object} data
 * @returns
 */
export function addRoleModelDefinition(data) {
  return request({
    url: '/model_definition/role_definition/insert',
    method: 'POST',
    data
  })
}

/**
 * 修改角色元件
 * @param {Object} data
 * @returns
 */
export function updateRoleModelDefinition(data) {
  return request({
    url: '/model_definition/role_definition/update',
    method: 'POST',
    data
  })
}

/**
 * 删除
 * @param {Object} data
 * @returns
 */
export function removeRoleModelDefinition(data) {
  return request({
    url: '/model_definition/role_definition/remove',
    method: 'POST',
    data
  })
}

/**
 * 添加角色元件
 * @param {Object} data
 * @returns
 */
export function getRoleModelDefinitionById(data) {
  return request({
    url: '/model_definition/role_definition/getById',
    method: 'get',
    data
  })
}